import Vue from 'vue'
import Vuex from 'vuex'
import Vue2TouchEvents from 'vue2-touch-events'
import VueObserveVisibility from 'vue-observe-visibility'
import WayfinderVueComponents from '@3dwayfinder/wayfinder-vue-components';
import { loadWayfinder } from '@3dwayfinder/wayfinder-vue-components';

import App from './App.vue'
import './registerServiceWorker'
import "./css/index.css"

Vue.use(Vuex);
Vue.use(VueObserveVisibility);
Vue.use(Vue2TouchEvents, {tapTolerance: 15, 
	touchHoldTolerance: 600,
    swipeTolerance: 100,
    longTapTimeInterval: 600,
	touchClass: 'wf-touch'
});

Vue.config.productionTip = false
//import { createLogger } from 'vuex'

const WF_MAP_TYPE = "3d2";
const WF_PROJECT = "a3427e77f85a9a6372c6247c9a17701d";
const WF_API = "cdn";

const DO_TOKEN = "Vh1EyM89YyscXq9Hk0kfFzldQjaae1BO";
Vue.prototype.$DO_TOKEN = DO_TOKEN;

const dayjs = require('dayjs')
const format = "DD.MM.YYYY";
/*const myPluginWithSnapshot = store => {
  store.subscribe((mutation, state) => {
    console.log('mut', mutation, state);
  })
}*/

const store = new Vuex.Store({
	//plugins: [myPluginWithSnapshot],
	state: {
		appName: "Wayfinder Vue Components",
		currentPOI: null,
		currentGroup: null,
		defaultGroup: null,
		searchVisible: false,
		currentTab: "map",
		currentPage: null,
		activities: [],
		log: [],
		offers: [],
		news: [],
		map360: "",
		navbar: false,
		routeBTN: false,
		lastTab: "",
		goback: -1,
		currentOffer: null,
		mapTab: ""
	},
	mutations: {
		setPOI (state, poi) {
			state.currentPOI = poi;
		},
		setGroup (state, group ) {
			state.currentGroup = group;
		},
		setDefaultGroup (state, group ) {
			state.defaultGroup = group;
		},
		showSearch (state, show) {
			state.searchVisible = show;
		},
		setTab (state, tab) {
			state.currentTab = tab;
		},
		setPage (state, page) {
			state.currentPage = page;
		},
		activities (state, activities) {
			state.activities = activities;
		},
		pushLog (state, log) {
			if (state.log.length > 25) {
				state.log.shift();
			}
			state.log.push(log);
		},
		offers (state, offers) {
			if (offers) {
				state.offers = offers.map((o) => {
					o.floor = o.partner && o.partner.stores && o.partner.stores.length > 0 ? o.partner.stores[0].floor : '';
					o.valid =  dayjs(o.expiry_from).format(format) + " - " + dayjs(o.expiry_to).format(format);

					return o;
				});
			}
		},
		news (state, news) {
			state.news = news.map((n) => {
				n.strdate =  dayjs(n.date).format(format);
				return n;
			});
		},
		set360 (state, url) {
			state.map360 = url;
		},
		setNavbar (state, bar) {
			state.navbar = bar;
		},
		setBack (state, back) {
			state.goback = back;
		},
		setLastTab (state, tab) {
			state.lastTab = tab;
		},
		setOffer (state, offer) {
			state.currentOffer = offer;
		},
		setMapTab (state, tab) {
			state.mapTab = tab;
		}
	},
	actions: {
		setPOI : (context, poi) => {
			context.commit('setPOI', Object.freeze(poi));
			context.commit('setMapTab', "poi");
		},
		setGroup : (context, group) => {
			context.commit('setGroup', Object.freeze(group));
		},
		setDefaultGroup : (context, group) => {
			context.commit('setDefaultGroup', Object.freeze(group));
		},
		showSearch : (context, show) => {
			context.commit('showSearch',  show);
		},
		setTab : (context, show) => {

			context.commit('setTab', show);
		},
		setPage: (context, page) => {
			context.commit('setPage', page);
		},
		pushLog : (context, log) => {
			context.commit('pushLog', log);
		},
		getOffers: (ctx, options) => {
			let project = options.project;
			let pois = options.pois;

			fetch("https://do.3dwayfinder.com/api/r/astri/offers/et/" + project, {
				headers: {
					Authorization: `Bearer ${DO_TOKEN}`,
				}
			}).then(resp1 => resp1.json()).then((offers) => {
				let _offers = offers.offers.map(o => {
					if (o && o.partner && o.partner.stores && o.partner.stores.length > 0) {
						pois.forEach(p => {
							if (p && p.room_id == o.partner.stores[0].location_code) {
								o.poi = Object.freeze(p);
								return;
							}
						});
					}

					return o;
				})
				ctx.commit('offers', _offers);
			});
		},
		getNews: (ctx, project) => {
			fetch("https://do.3dwayfinder.com/api/r/astri/news/et/" + project, {
				headers: {
					Authorization: `Bearer ${DO_TOKEN}`,
				}
			}).then(resp1 => resp1.json()).then((options) => {
				ctx.commit('news', options);
			});
		},
		set360 : (context, url) => {
			context.commit('set360', url);
		},
		setNavbar: (context, bar) => {
			context.commit('setNavbar', bar);
		},
		setBack: (context) => {
			let lastTab = context.state.lastTab;
			context.commit('setNavbar', false);
			context.commit('setBack', Date.now());
			context.commit('setLastTab', "");
			context.commit('setOffer', null);
			context.commit('setPOI', null);

			if (lastTab) {
				context.commit('setTab', lastTab);
			}
		},
		setLastTab: (context, tab) => {
			context.commit('setLastTab', tab);
		},
		setOffer: (context, offer) => {
			context.commit('setOffer', offer);
			context.commit('setTab', "map");
			context.commit('setNavbar', true);
			context.commit('setLastTab', 'pakkumised');
			context.commit('setMapTab', "offer");
		},
		setMapTab: (context, tab) => {
			context.commit('setMapTab', tab);
		},
		clearNav: (context) => {
			context.commit('setNavbar', false);
			context.commit('setMapTab', "");
			context.commit('setLastTab', '');
			context.commit('setOffer', null);
			context.commit('setPOI', null);
			context.commit('setTab', "map");
			context.commit("showSearch", false);
			context.commit('set360', "");
		}
	}
})

loadWayfinder(WF_MAP_TYPE, "local", loadVue);

function loadVue () {
	new Vue({
		store,
		render: h => h(App),
		created () {
			
			/*let upscale = parseFloat(this.$wayfinder.options.upscale);
			if (upscale > 1 ) {
			upscale = 1.2;
			}
			else if (upscale < 1) {
			upscale = 0.5;
			}*/

			//this.$wayfinder.options.upscale = upscale;
			Vue.use(WayfinderVueComponents, this.$store, WF_MAP_TYPE, WF_PROJECT, WF_API)
			console.log('Initializing Wayfinder...', this.$wayfinder);
		}
	}).$mount('#app')
}
